





























import {Vue, Component, Prop} from "vue-property-decorator";
import {CommonConstant} from "@/common-constant";

@Component
export default class CustomerCodeGuide extends Vue {
    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    @Prop() private isVisible!: boolean;

    close() {
        this.$emit('close', null);
    }
}
